import { IconProps, Icon } from '@bnb-chain/space';

export function BinanceWeb3WalletIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <rect width="24" height="24" fill="#0B0E11" />
      <path
        d="M8.98987 10.7632L12 7.75312L15.0116 10.7648L16.7631 9.01321L12 4.25L7.23836 9.01166L8.98987 10.7632ZM6.00157 10.2483L7.75305 11.9998L6.00148 13.7514L4.25 11.9999L6.00157 10.2483ZM8.98987 13.2368L12 16.2468L15.0115 13.2353L16.764 14.9859L16.7631 14.9868L12 19.75L7.2383 14.9883L7.23585 14.9859L8.98987 13.2368ZM19.75 12.0002L17.9985 13.7517L16.247 12.0002L17.9985 10.2487L19.75 12.0002Z"
        fill="#F0B90B"
      />
      <path
        d="M13.7764 11.9991H13.7772L11.9999 10.2217L10.2217 12L10.2241 12.0024L11.9999 13.7782L13.7781 12L13.7764 11.9991Z"
        fill="#F0B90B"
      />
    </Icon>
  );
}
